export type DocFormulaEvalResult =
  | { ok: true; value: number; display: string }
  | { ok: false; error: string };

export const DOC_FORMULA_UNRESOLVED_DISPLAY = "—";
